import cn from "classnames";

export const StatusDot = ({ status }) => {
  const classNames = cn("h-3.5 w-3.5 rounded-full border border-gray-200", {
    "bg-emerald-600": status === "green",
    "bg-yellow-500": status === "yellow",
    "bg-red-600": status === "red",
    "bg-gray-200": !status,
  });

  return <div className={classNames} />;
};
